"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamRoutes = void 0;
const base_1 = require("../base");
const constants_1 = require("../constants");
/**
 * API routes for stream management
 * Handles live stream data and monitoring
 */
class StreamRoutes extends base_1.ApiBase {
    /**
     * Get live streams from the API
     * @returns Promise resolving to array of live Twitch streams
     * @throws Error if the API request fails
     */
    async getLivestreams() {
        return this.apiGet(`${constants_1.ROUTES.STREAMS}/live`);
    }
}
exports.StreamRoutes = StreamRoutes;
//# sourceMappingURL=streams.js.map